var _text, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLarsenToubro({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 68,
    textAnchor: "middle",
    fontFamily: "Arial Black,Arial,sans-serif",
    fontWeight: 900,
    fontSize: 42,
    fill: "#0a4a8f"
  }, "L&amp;T")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 82,
    width: 100,
    height: 5,
    fill: "#0a4a8f",
    opacity: 0.35
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLarsenToubro);
export default __webpack_public_path__ + "static/media/larsen-toubro.5f9627eb766084d78122c518bb8ed825.svg";
export { ForwardRef as ReactComponent };